import { BaseModel, Workflow } from '@nimmsta/ng-commons-lib/models';
import { IconAction } from '@nimmsta/ng-commons-lib/data-table';
import { Observable, of } from 'rxjs';
import {
  hasWorkflowMediaContent,
  WorkflowMediaPresenceInput,
} from './workflow-media-preview.util';

export class ShowWorkflowIconAction<
  T extends BaseModel & WorkflowMediaPresenceInput = Workflow,
> extends IconAction<T> {
  constructor() {
    super('show', 'visibility');
  }

  override isEnabled(item: T): Observable<boolean> {
    if (hasWorkflowMediaContent(item)) {
      return of(true);
    } else {
      return of(false);
    }
  }
}
